"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var styles = tslib_1.__importStar(require("./Info.style"));

var ic_info_sm_line_gray_700_svg_1 = tslib_1.__importDefault(require("../../assets/ic-info-sm-line-gray-700.svg"));

function Info(_ref) {
  var className = _ref.className,
      title = _ref.title,
      content = _ref.content,
      _ref$showInfoIcon = _ref.showInfoIcon,
      showInfoIcon = _ref$showInfoIcon === void 0 ? true : _ref$showInfoIcon;
  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.container(showInfoIcon)
  }, {
    children: [showInfoIcon && jsx_runtime_1.jsx("img", {
      css: styles.infoIcon,
      src: ic_info_sm_line_gray_700_svg_1.default,
      alt: "info"
    }, void 0), jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.contentContainer
    }, {
      children: [title && jsx_runtime_1.jsx("div", Object.assign({
        css: styles.title
      }, {
        children: title
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({
        css: styles.content
      }, {
        children: content
      }), void 0)]
    }), void 0)]
  }), void 0);
}

exports.default = Info;